import { createContext, ReactNode, useContext, useState } from 'react';

export type SidebarSize = 'large' | 'small';

interface SidebarContextData {
  navSize: SidebarSize;
  setNavSize: (tamanho: SidebarSize) => void;
  larguraAtual: string;
}

const SidebarContext = createContext<SidebarContextData>(
  {} as SidebarContextData
);

// Larguras espelham o que SiderbarResponsive sempre usou: "large" = recolhida
// (só ícone, 65px), "small" = expandida no hover (com rótulos, 250px). Os nomes
// são contraintuitivos (herdados do componente original), mas preservados aqui
// pra não precisar renomear os dois lados junto.
const LARGURAS: Record<SidebarSize, string> = {
  large: '65px',
  small: '250px',
};

interface SidebarProviderProps {
  children: ReactNode;
}

// Antes, SiderbarResponsive controlava seu próprio navSize (useState local) e
// Wapper reservava uma margem fixa de 65px — quando a sidebar expandia no
// hover pra 250px, o conteúdo da página não acompanhava e ficava coberto.
// Centralizando o estado aqui, Wapper consegue reagir à mesma expansão.
export function SidebarProvider({ children }: SidebarProviderProps) {
  const [navSize, setNavSize] = useState<SidebarSize>('large');

  return (
    <SidebarContext.Provider
      value={{ navSize, setNavSize, larguraAtual: LARGURAS[navSize] }}
    >
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  return useContext(SidebarContext);
}
